"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
function default_1({ children }) {
    (0, react_1.useEffect)(() => {
        const syncContainer = document.getElementById('scroll_sync_container_pc');
        const adjustTopOnScroll = () => {
            const scrollDistance = document.documentElement.scrollTop;
            syncContainer.style.top = `${scrollDistance}px`;
        };
        window.addEventListener('scroll', adjustTopOnScroll);
        return () => {
            window.removeEventListener('scroll', adjustTopOnScroll);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: "scroll_sync_container_pc", css: {
            position: 'absolute',
            left: 'calc(100% + 10px)',
            '@media (max-width: 1440px)': { left: 'calc(100% - 180px)' },
            display: 'flex',
            flexDirection: 'column',
            rowGap: '14px',
            width: '180px',
            padding: '28px 0',
            '@media (max-width: 1080px)': {
                paddingRight: '16px',
            },
        } }, { children: children })));
}
exports.default = default_1;
